// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgAdminMark24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path d="M15.7991 12.2264L13.5932 8.94043C14.2902 8.43489 14.7268 7.61532 14.7268 6.73447C14.7268 5.22553 13.5013 4 11.9923 4C10.4834 4 9.25787 5.22553 9.25787 6.73447C9.25787 7.63064 9.68681 8.43489 10.3838 8.94043L8.13957 12.234L3 4.57447V19.6715H21V4.63574L15.7991 12.2264ZM12 6.10638C12.3447 6.10638 12.6281 6.38979 12.6281 6.73447C12.6281 7.07915 12.3447 7.36255 12 7.36255C11.6553 7.36255 11.3719 7.07915 11.3719 6.73447C11.3719 6.38979 11.6553 6.10638 12 6.10638ZM8.14723 15.9872L12 10.3345L15.7838 15.9872L18.9013 11.4374V17.5651H5.10638V11.4681L8.14723 15.9796V15.9872Z" />
			</Svg>
		);
	}
);
SvgAdminMark24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgAdminMark24;
